import { render, staticRenderFns } from "./BestPromocja.html?vue&type=template&id=35306dc9&scoped=true&external"
import script from "./BestPromocja.js?vue&type=script&lang=js&external"
export * from "./BestPromocja.js?vue&type=script&lang=js&external"
import style0 from "./BestPromocja.css?vue&type=style&index=0&id=35306dc9&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35306dc9",
  null
  
)

export default component.exports